import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import * as t from "@babel/types";
import { validateEmbeddedExpression } from "./validations.js";
import { replaceBindings } from "./replaceBindings.js";
import { parseChildren } from "./parseChildren.js";
var ambiguousSymbol = Symbol("ambiguous");
export function parseJsValue(path, state, app, options) {
  if (path.isTSAsExpression()) {
    return parseJsValue(path.get("expression"), state, app, options);
  }
  if (path.isObjectExpression()) {
    return parseJsObject(path, state, app, options);
  }
  if (path.isArrayExpression()) {
    return parseJsArray(path, state, app, options);
  }
  if (path.isStringLiteral() || path.isNumericLiteral() || path.isBooleanLiteral()) {
    return path.node.value;
  }
  if (path.isNullLiteral()) {
    return null;
  }
  if (path.isIdentifier() && path.node.name === "undefined" && path.scope.getBinding("undefined") === undefined) {
    return undefined;
  }
  if (options.allowUseBrick && path.isArrowFunctionExpression()) {
    var expr = path.get("body");
    if (expr.isBlockStatement()) {
      state.errors.push({
        message: "Block statements are not supported in render callback",
        node: expr.node,
        severity: "error"
      });
      return null;
    }
    var paramNames = [];
    var _iterator = _createForOfIteratorHelper(path.get("params")),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var param = _step.value;
        if (param.isIdentifier()) {
          paramNames.push(param.node.name);
        } else {
          state.errors.push({
            message: "Unsupported parameter type: ".concat(param.type),
            node: param.node,
            severity: "error"
          });
          return null;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return {
      params: paramNames,
      children: parseChildren(expr, state, app, options)
    };
  }
  if (path.isExpression()) {
    if (!validateEmbeddedExpression(path.node, state)) {
      return null;
    }
    if (options.ambiguous) {
      return ambiguousSymbol;
    }
    return replaceBindings(path, state, app, options);
  }
  state.errors.push({
    message: "Unsupported value type: ".concat(path.node.type),
    node: path.node,
    severity: "error"
  });
  return null;
}
export function parsePropValue(path, state, app, options) {
  var shouldCompute = false;
  t.traverse(path.node, {
    enter: function enter(node, parent) {
      var _parent;
      var p;
      if (!shouldCompute && !(t.isStringLiteral(node) || t.isNumericLiteral(node) || t.isBooleanLiteral(node) || t.isNullLiteral(node) || t.isObjectExpression(node) || t.isArrayExpression(node) || t.isObjectProperty(node) || t.isIdentifier(node) && (p = (_parent = parent[parent.length - 1]) === null || _parent === void 0 ? void 0 : _parent.node, true) && (p && t.isObjectProperty(p) ? !p.computed && !p.shorthand : node.name === "undefined"))) {
        shouldCompute = true;
      }
    }
  });
  if (shouldCompute && validateEmbeddedExpression(path.node, null)) {
    return replaceBindings(path, state, app, options);
  }
  return parseJsValue(path, state, app, options);
}
function parseJsObject(path, state, app, options) {
  var props = path.get("properties");
  if (props.some(function (p) {
    return p.isSpreadElement() || p.isObjectProperty() && (p.node.computed || p.node.shorthand);
  }) && validateEmbeddedExpression(path.node, state)) {
    if (options.ambiguous) {
      return ambiguousSymbol;
    }
    return replaceBindings(path, state, app, options);
  }
  var result = {};
  var _iterator2 = _createForOfIteratorHelper(props),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var prop = _step2.value;
      if (!prop.isObjectProperty()) {
        state.errors.push({
          message: "Unsupported property type: ".concat(prop.type),
          node: prop.node,
          severity: "error"
        });
        continue;
      }
      if (prop.node.computed || prop.node.shorthand) {
        state.errors.push({
          message: "Unsupported computed or shorthand object property",
          node: prop.node.key,
          severity: "error"
        });
        continue;
      }
      var keyPath = prop.get("key");
      var key = void 0;
      if (keyPath.isIdentifier()) {
        key = keyPath.node.name;
      } else if (keyPath.isStringLiteral()) {
        key = keyPath.node.value;
      } else {
        state.errors.push({
          message: "Unsupported object key type: ".concat(keyPath.node.type),
          node: keyPath.node,
          severity: "error"
        });
        continue;
      }
      result[key] = parseJsValue(prop.get("value"), state, app, options);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return result;
}
function parseJsArray(path, state, app, options) {
  var elements = path.get("elements");
  if (elements.some(function (e) {
    return !e || e.isSpreadElement();
  }) && validateEmbeddedExpression(path.node, state)) {
    if (options.ambiguous) {
      return ambiguousSymbol;
    }
    return replaceBindings(path, state, app, options);
  }
  var result = [];
  var _iterator3 = _createForOfIteratorHelper(elements),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var elem = _step3.value;
      if (!elem.node) {
        state.errors.push({
          message: "Array elements cannot be empty",
          node: path.node,
          severity: "error"
        });
        continue;
      }
      if (elem.isSpreadElement()) {
        state.errors.push({
          message: "Spread elements are not supported in array",
          node: elem.node,
          severity: "error"
        });
        continue;
      }
      result.push(parseJsValue(elem, state, app, options));
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return result;
}
//# sourceMappingURL=parseJsValue.js.map